/* eslint-disable */
export enum PartnerOrganizationActionTypes {
  SET_LAYOUT = "@@PartnerOrganization/initialization/SET_LAYOUT",
}
